<template>
  <div class="p-6">
    <div class="flex flex-col w-full mb-4">
      <label class="font-semibold text-sm text-grey-700 mb-2">
        {{ $t(nameFieldHeaderText) }}
      </label>
      <text-input
        variant="base"
        v-model="model.name"
        :validator="$v.model.name"
        :placeholder="this.$t(placeholderText)"
      />
    </div>

    <div class="flex justify-end">
      <gd-button
        size="auto"
        @click="closeModal"
        >{{ $t('frontend_cancel') }}</gd-button
      >
      <gd-button
        class="ml-2"
        size="auto"
        variant="primary"
        @click="executeAction"
      >
        {{ $t(actionButtonText) }}
      </gd-button>
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      model: {
        name: '',
      },
    };
  },

  props: {
    name: {
      required: true,
    },
    nameFieldHeaderText: {
      required: true,
    },
    actionButtonText: {
      required: true,
    },
    placeholderText: {
      required: false,
      default: 'frontend_name',
    },
  },

  validations: {
    model: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
    },
  },

  created() {
    this.model.name = this.name;
  },

  methods: {
    closeModal() {
      this.$emit('closeModal');
    },

    executeAction() {
      this.$v.model.name.$touch();
      if (!this.$v.model.name.$invalid) {
        this.$emit('executeAction', this.model.name);
      }
    },
  },
};
</script>
